/**
 * BSM inline glossary terms: **term** or **term**(definition)
 * Definitions in parentheses are hidden from the visible text and shown on hover.
 */

export type InlineTextSegment =
  | { type: 'plain'; text: string }
  | { type: 'term'; term: string; definition?: string };

const INLINE_TERM_PATTERN = /\*\*([^*|]+)\*\*(?:\(([^)]*)\))?/g;

export function parseInlineTerms(input: string): InlineTextSegment[] {
  if (!input) return [{ type: 'plain', text: '' }];

  const segments: InlineTextSegment[] = [];
  let lastIndex = 0;

  for (const match of input.matchAll(INLINE_TERM_PATTERN)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      segments.push({ type: 'plain', text: input.slice(lastIndex, matchIndex) });
    }
    segments.push({
      type: 'term',
      term: match[1] ?? '',
      definition: match[2] || undefined,
    });
    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < input.length) {
    segments.push({ type: 'plain', text: input.slice(lastIndex) });
  }

  return segments.length > 0 ? segments : [{ type: 'plain', text: input }];
}

export function getVisibleTextFromInlineTerms(input: string): string {
  return parseInlineTerms(input)
    .map((segment) => (segment.type === 'plain' ? segment.text : segment.term))
    .join('');
}
